export default "__VITE_ASSET__ByeOsk44__"